// extracted by mini-css-extract-plugin
export var avatar = "_s3-3";
export var avatarContainer = "_s3-2";
export var avatarSpacer = "_s3-5";
export var avatarSpacerContainer = "_s3-4";
export var avatarStackContainer = "_s3-1";
export var bubble = "_s3-0";
export var remainderBubble = "_s3-6";